export default function(type, element, content, children) {
    if (type === 'preformatted') {
        return `${element.text}`
    }
    if (type === 'image') {
        return `<p class=" block-img"><img src="${element.url}" alt="${element.alt || ''}" copyright="${element.copyright || ''}" loading="lazy"></p>`
    }
}